import { render, staticRenderFns } from "./stateDetailEdit.vue?vue&type=template&id=52504051&scoped=true&"
import script from "./stateDetailEdit.vue?vue&type=script&lang=ts&"
export * from "./stateDetailEdit.vue?vue&type=script&lang=ts&"
import style0 from "./stateDetailEdit.vue?vue&type=style&index=0&id=52504051&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52504051",
  null
  
)

export default component.exports